export default "__VITE_ASSET__DSdd3QWb__"